import React from "react";
import { getContentLanguage } from "static-content/view/api";
import { AhpSlider } from "../ahp-slider/AhpSlider";
import { DbotButtonContainer } from "../dbot-button/DbotButtonContainer";
import { ButtonContainer, LegendWrapper } from "./ButtonPanelStyles";

export const ButtonsPanel = (props, buttonsDelay, appMode, useState) => {
  if (props == null) return;
  const key = `${props.blockApi.blockName}_${props.buttons[0] !== undefined ? props.buttons[0].pointer : ""}`;
  const totalButtons = window.OPSEEKER_CONFIG.LIKERT_SCALE_TOTAL ? window.OPSEEKER_CONFIG.LIKERT_SCALE_TOTAL : 5;
  return (
    <>
      <ButtonContainer className={props.tag} delay={buttonsDelay} key={key}>
        {props.tag === "likert" ? (
          [...Array(totalButtons)].map((b, index) => (
            <DbotButtonContainer
              button={props.buttons[0]}
              blockApi={props.blockApi}
              key={index}
              onClickButton={props.onClickButton}
              onClickImage={props.onClickImage}
              appMode={appMode}
              variables={props.variables}
              sequence={index}
              tag={props.tag}
              totalButtons={totalButtons}
            />
          ))
        ) : props.tag === "ahp" ? (
          <AhpSlider useState={useState} options={props.buttons} onClickButton={props.onClickButton} />
        ) : (
          props.buttons.map(function(button, index) {
            return (
              <DbotButtonContainer
                button={button}
                blockApi={props.blockApi}
                key={index}
                onClickButton={props.onClickButton}
                onClickImage={props.onClickImage}
                appMode={appMode}
                variables={props.variables}
                sequence={index}
                tag={props.tag}
              />
            );
          })
        )}
      </ButtonContainer>
      {props.tag === "likert" && renderLegend(getContentLanguage(), buttonsDelay, totalButtons)}
    </>
  );
};

const renderLegend = (language, buttonsDelay, totalButtons) => {
  const labels = !language || language === 'ES' ? ES_LABELS : EN_LABELS
  return (
  <LegendWrapper delay={buttonsDelay} totalButtons={totalButtons}>
    <p>{labels[0]}</p>
    <p>{labels[1]}</p>
  </LegendWrapper>
    )
  };

const EN_LABELS = ['Disagree', 'Agree']
const ES_LABELS = ['En desacuerdo', 'De acuerdo']